import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import Table from '@/store/modules/Table'

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
	modules: {
		Table
	}
}
